import { render, staticRenderFns } from "./preBroadcast.vue?vue&type=template&id=b6c33616&scoped=true&"
import script from "./preBroadcast.vue?vue&type=script&lang=js&"
export * from "./preBroadcast.vue?vue&type=script&lang=js&"
import style0 from "./preBroadcast.vue?vue&type=style&index=0&id=b6c33616&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c33616",
  null
  
)

export default component.exports